( function () {
    'use strict';
    espresso.bootstrap = {};
    espresso.bootstrap.init = function () {
        espresso.bootstrap.form.init();
        espresso.bootstrap.carousel.init();
        espresso.bootstrap.affix.init();
        espresso.bootstrap.modal.init();
        espresso.bootstrap.dropdown.fixTouchClickIssue();
        espresso.bootstrap.tabs.onFocusThisBlur();
    };
    // Konstruer et object indeholdende alle validations pluginets stadard settings
    // lav 'groups regler' til at håndterer post og by i control-rows
    espresso.bootstrap.form = {};
    espresso.bootstrap.form.init = function () {
        if ( jQuery( 'form' ).length > 0 ) {
            espresso.bootstrap.form.validation.setDefaults();
            espresso.bootstrap.form.build();
            espresso.bootstrap.form.validation.loadLocalLang();
        }
    };
    espresso.bootstrap.form.build = function () {
        var jDynamicwebForms = jQuery( '.postform,form[name^="postform"]' ),
            jFieldsetTemplate = jQuery( '<fieldset />' );
        jDynamicwebForms.find( '.formtablecontainer' ).css( {
            visibility: 'hidden'
        } ).end();
        if ( jDynamicwebForms.length === 0 ) {
            return;
        }
        jDynamicwebForms.each( function ( index ) {
            var jOriginalForm = jQuery( this ),
                jTempForm = jQuery( '<form />' ),
                arrNewFormElements = [],
                jNewFieldset = jFieldsetTemplate.clone(),
                inputClass = 'input-block-level',
                usePlaceholder = false;
            jOriginalForm.find( 'input[type="hidden"]' ).appendTo( jTempForm );
            jOriginalForm.find( ':input' ).removeAttr( 'style' );
            jOriginalForm.find( 'td > table td' ).each( function () {
                var jOriginalFormTdEach = jQuery( this );
                //if(jOriginalForm.is('.postform,form[name^="postform"]') === true && jOriginalFormTdEach.find('input[type="text"]').length > 0) {
                if ( jOriginalFormTdEach.find( 'input[type="text"]' ).length > 0 ) {
                    if ( jOriginalFormTdEach.siblings( 'td' ).length > 0 ) {
                        //jOriginalForm.attr('class', 'form-horizontal');
                        usePlaceholder = ( 'placeholder' in document.createElement( 'input' ) );
                    }
                    else {
                        //jOriginalForm.attr('class', 'form-vertical');
                    }
                    jOriginalForm.attr( 'class', 'form-vertical' );
                }
                if ( jOriginalFormTdEach.find( 'table' ).is( 'table table table' ) ) {
                    arrNewFormElements.push( {
                        type: 'separator'
                    } );
                }
                else if ( jOriginalFormTdEach.find( ':input' ).length > 0 ) {
                    arrNewFormElements.push( {
                        type: ( function () {
                            if ( jOriginalFormTdEach.find( 'input[type="checkbox"]' ).length > 0 ) {
                                return 'input-checkbox';
                            }
                            if ( jOriginalFormTdEach.find( 'input[type="radio"]' ).length > 0 ) {
                                return 'input-radio';
                            }
                            if ( jOriginalFormTdEach.find( 'textarea' ).length > 0 ) {
                                return 'input-textarea';
                            }
                            if ( jOriginalFormTdEach.find( 'select' ).length > 0 ) {
                                return 'input-select';
                            }
                            if ( jOriginalFormTdEach.find( 'input[type="button"],input[type="reset"]' ).length > 0 ) {
                                return 'input-button';
                            }
                            else {
                                return 'input';
                            }
                        }() ),
                        content: jOriginalFormTdEach.html(),
                        required: jOriginalFormTdEach.find( 'img:last-child' ).length
                    } );
                }
                else if ( jOriginalFormTdEach.is( 'td[colspan="2"]' ) ) {
                    arrNewFormElements.push( {
                        type: 'legend',
                        content: jOriginalFormTdEach.html()
                    } );
                }
                else if ( jOriginalFormTdEach.text() !== '' ) {
                    arrNewFormElements.push( {
                        type: 'label',
                        content: jOriginalFormTdEach.text(),
                        required: jOriginalFormTdEach.find( 'img:last-child' ).length
                    } );
                }
            } );
            for ( var i = 0; i < arrNewFormElements.length; i++ ) {
                //console.log(arrNewFormElements[i].type)
                var jControlGroup = jQuery( '<div class="control-group">' + '</div>' ),
                    jInput;
                if ( arrNewFormElements[ i ].type === 'legend' ) {
                    jNewFieldset.append( '<p>' + arrNewFormElements[ i ].content + '</p>' );
                }
                else if ( arrNewFormElements[ i ].type === 'input-radio' ) {
                    if ( arrNewFormElements[ i - 1 ].type === 'label' ) {
                        if ( arrNewFormElements[ i - 1 ].required ) {
                            jControlGroup.addClass( 'required' );
                        }
                        jControlGroup.append( '<label class="control-label">' + arrNewFormElements[ i - 1 ].content + '</label>' );
                    }
                    jControlGroup.append( '<div class="controls">' + '</div>' );
                    jControlGroup = jControlGroup.find( '.controls' );
                    var jFormControlRadio = jQuery( arrNewFormElements[ i ].content ),
                        radioGroupName = jFormControlRadio.filter( 'input' ).attr( 'name' );
                    while ( i < arrNewFormElements.length && ( arrNewFormElements[ i ].type === 'input-radio' && jQuery( arrNewFormElements[ i ].content ).filter( 'input' ).attr( 'name' ) === radioGroupName ) || ( arrNewFormElements[ i ].type === 'label' && jQuery.trim( arrNewFormElements[ i ].content ) === '' ) ) {
                        jFormControlRadio = jQuery( arrNewFormElements[ i ].content );
                        jControlGroup.append( jFormControlRadio.filter( 'label' ).addClass( 'radio' ).prepend( jFormControlRadio.filter( 'input' ).removeClass() ) );
                        i++;
                    }
                    i--;
                    jControlGroup = jControlGroup.parent();
                    jControlGroup.appendTo( jNewFieldset );
                }
                else if ( arrNewFormElements[ i ].type === 'input-select' ) {
                    if ( arrNewFormElements[ i - 1 ].type === 'label' ) {
                        if ( arrNewFormElements[ i - 1 ].required ) {
                            jControlGroup.addClass( 'required' );
                        }
                        if ( jQuery( arrNewFormElements[ i ].content ).filter( 'input[name*="Mail"],input[name*="mail"]' ).length > 0 ) {
                            jControlGroup.addClass( 'email' );
                        }
                        jControlGroup.append( '<label class="control-label" for="input_' + index + '_' + i + '">' + arrNewFormElements[ i - 1 ].content + '</label>' );
                    }
                    jControlGroup.append( '<div class="controls">' + arrNewFormElements[ i ].content + '</div>' ).find( '.controls:last > :input' ).attr( 'id', 'input_' + index + '_' + i ).addClass( inputClass );
                    var aSelect = jControlGroup.find( 'select' );
                    if ( aSelect.length === 1 ) {
                        aSelect.find( 'option[value="invalid"]' ).attr( 'value', '' );
                        if ( aSelect.is( '[name="ReplaceRecipient"]' ) === true ) {
                            aSelect.on( 'change', function () {
                                var jThis = jQuery( this );
                                if ( co3.util.validateEmail( jThis.val() ) || co3.util.validateEmail( jThis.val().split( ',' )[ 0 ] ) ) {
                                    jQuery( this.form ).find( 'input[name="Recipient"]' ).val( jThis.val() );
                                }
                                else {
                                    jQuery( this.form ).find( 'input[name="Recipient"]' ).val( jThis.data( 'Original-Recipient' ) );
                                }
                            } ).data( {
                                'Original-Recipient': jQuery( 'input[name="Recipient"]' ).val()
                            } );
                        }
                    }
                    jControlGroup.appendTo( jNewFieldset );
                }
                else if ( arrNewFormElements[ i ].type === 'input-checkbox' ) {
                    jControlGroup.append( '<div class="controls">' + '</div>' );
                    while ( i < arrNewFormElements.length && arrNewFormElements[ i ].type === 'input-checkbox' ) {
                        var jFormControlCheckbox = jQuery( arrNewFormElements[ i ].content );
                        jControlGroup.find( '.controls' ).append( jFormControlCheckbox.filter( 'label' ).addClass( 'checkbox' ).prepend( jFormControlCheckbox.filter( 'input' ).removeClass().addClass( function () {
                            return ( this.name.indexOf( 'required' ) > -1 ? 'required' : '' );
                        } ) ) );
                        i++;
                    }
                    i--;
                    jControlGroup.appendTo( jNewFieldset );
                }
                else if ( arrNewFormElements[ i ].type === 'input-textarea' ) {
                    if ( arrNewFormElements[ i - 1 ].type === 'label' ) {
                        if ( arrNewFormElements[ i - 1 ].required ) {
                            jControlGroup.addClass( 'required' );
                        }
                        if ( usePlaceholder === false ) {
                            jControlGroup.append( '<label class="control-label" for="input_' + index + '_' + i + '">' + arrNewFormElements[ i - 1 ].content + '</label>' );
                        }
                    }
                    jInput = jControlGroup.append( '<div class="controls">' + arrNewFormElements[ i ].content + '</div>' ).find( '.controls:last > :input' ).attr( 'id', 'input_' + index + '_' + i ).addClass( inputClass );
                    if ( usePlaceholder === true ) {
                        jInput.attr( 'placeholder', arrNewFormElements[ i - 1 ].content );
                    }
                    jControlGroup.appendTo( jNewFieldset );
                }
                else if ( arrNewFormElements[ i ].type === 'input' ) {
                    if ( arrNewFormElements[ i - 1 ].type === 'label' ) {
                        if ( arrNewFormElements[ i - 1 ].required ) {
                            jControlGroup.addClass( 'required' );
                        }
                        if ( jQuery( arrNewFormElements[ i ].content ).filter( 'input[name*="Mail"],input[name*="mail"]' ).length > 0 ) {
                            jControlGroup.addClass( 'email' );
                        }
                        if ( usePlaceholder === false ) {
                            jControlGroup.append( '<label class="control-label" for="input_' + index + '_' + i + '">' + arrNewFormElements[ i - 1 ].content + '</label>' );
                        }
                    }
                    jInput = jControlGroup.append( '<div class="controls">' + arrNewFormElements[ i ].content + '</div>' ).find( '.controls:last > :input' ).attr( 'id', 'input_' + index + '_' + i ).addClass( inputClass );
                    if ( usePlaceholder === true ) {
                        jInput.attr( 'placeholder', arrNewFormElements[ i - 1 ].content );
                    }
                    jControlGroup.appendTo( jNewFieldset );
                }
                else if ( arrNewFormElements[ i ].type === 'input-button' ) {
                    jControlGroup = jQuery( '<div class="form-actions">' + '</div>' );
                    jQuery( arrNewFormElements[ i ].content ).filter( 'input' ).addClass( 'btn' ).removeAttr( 'onclick' ).first().addClass( 'btn-primary' ).end().each( function () {
                        var jThis = jQuery( this );
                        jControlGroup.append( function () {
                            if ( jThis.is( '.btn-primary' ) ) {
                                return jQuery( '<input>' ).attr( {
                                    'type': 'submit',
                                    'name': jThis.val(),
                                    'value': jThis.val(),
                                    'class': jThis.attr( 'class' ) + ( arrNewFormElements.length > 3 ? ' btn-large' : '' )
                                } ).after( ' ' );
                            }
                            else {
                                return jThis.addClass( 'btn-link' );
                            }
                        } );
                    } );
                    jControlGroup.appendTo( jNewFieldset );
                }
                else if ( arrNewFormElements[ i ].type === 'separator' ) {
                    jNewFieldset.append( '<hr>' );
                }
            }
            jTempForm.children().appendTo( jOriginalForm.empty().append( jNewFieldset ) );
            jOriginalForm.find( '.required :input' ).addClass( 'required' );
            jOriginalForm.find( '.email :input' ).addClass( 'email' );
            jOriginalForm.removeAttr( 'onsubmit' ).removeAttr( 'style' ).validate( {
                submitHandler: function ( form ) {
                    form.action = '/Admin/Public/FormMail.aspx?mode=20';
                    form.submit();
                }
            } );
            //jOriginalForm.closest('[class^="span"]').wrapInner('<div class="well" />');
        } );
    };
    espresso.bootstrap.form.validation = {};
    espresso.bootstrap.form.validation.init = function () {};
    espresso.bootstrap.form.validation.setDefaults = function () {
        jQuery.validator.setDefaults( {
            errorElement: 'small',
            errorPlacement: function ( error, element ) {
                if ( element.parent().is( 'label.radio' ) ) {
                    error.addClass( 'help-block' ).appendTo( element.closest( '.controls' ) );
                }
                if ( element.parent().is( 'label.checkbox' ) ) {
                    error.addClass( 'help-block' ).appendTo( element.parent() );
                }
                else if ( element.next().is( '.help-block' ) ) {
                    error.addClass( 'help-inline' ).insertAfter( element );
                }
                else {
                    if ( element.closest( 'form' ).is( '.form-vertical' ) ) {
                        error.addClass( 'help-block' ).appendTo( element.closest( '.controls' ) );
                    }
                    else {
                        error.addClass( 'help-inline' ).appendTo( element.closest( '.controls' ) );
                    }
                }
            },
            highlight: function ( element, errorClass, validClass ) {
                var jElement = jQuery( element );
                if ( jElement.parent().is( 'label.checkbox' ) ) {
                    jElement.parent().addBack().addClass( errorClass ).removeClass( validClass );
                }
                else {
                    jElement.closest( '.control-group' ).addBack().addClass( errorClass ).removeClass( validClass );
                }
            },
            unhighlight: function ( element, errorClass, validClass ) {
                var jElement = jQuery( element ),
                    jControlGroup = jElement.closest( '.control-group' );
                jElement.addClass( validClass ).removeClass( errorClass );
                if ( jControlGroup.find( errorClass ).length === 0 ) {
                    jControlGroup.addClass( validClass ).removeClass( errorClass );
                }
                if ( jElement.parent().is( 'label.checkbox' ) ) {
                    jElement.parent().addBack().addClass( validClass ).removeClass( errorClass );
                }
            },
            submitHandler: function ( form ) {
                form.submit();
            }
        } );
    };
    espresso.bootstrap.form.validation.loadLocalLang = function () {
        if ( espresso.config.pageLanguage === 'da' ) {
            /*
             * Translated default messages for the jQuery validation plugin.
             * Locale: DA
             */
            jQuery.extend( jQuery.validator.messages, {
                required: 'Dette felt er påkrævet.',
                maxlength: jQuery.validator.format( 'Indtast højst {0} tegn.' ),
                minlength: jQuery.validator.format( 'Indtast mindst {0} tegn.' ),
                rangelength: jQuery.validator.format( 'Indtast mindst {0} og højst {1} tegn.' ),
                email: 'Indtast en gyldig email-adresse.',
                url: 'Indtast en gyldig URL.',
                date: 'Indtast en gyldig dato.',
                number: 'Indtast et tal.',
                digits: 'Indtast kun hele tal.',
                equalTo: 'Indtast den samme værdi igen.',
                range: jQuery.validator.format( 'Angiv en værdi mellem {0} og {1}.' ),
                max: jQuery.validator.format( 'Angiv en værdi der højst er {0}.' ),
                min: jQuery.validator.format( 'Angiv en værdi der mindst er {0}.' ),
                creditcard: 'Indtast et gyldigt kreditkortnummer.'
            } );
        }
        else if ( espresso.config.pageLanguage !== 'en' ) {
            if ( espresso.config.pageLanguage === 'nb' || espresso.config.pageLanguage === 'nn' ) {
                espresso.config.pageLanguage = 'no';
            }
            jQuery.ajax( {
                url: '//ajax.aspnetcdn.com/ajax/jquery.validate/1.11.0/localization/messages_' + espresso.config.pageLanguage + '.js',
                dataType: 'script',
                cache: true
            } );
        }
    };
    espresso.bootstrap.carousel = {};
    espresso.bootstrap.carousel.init = function () {
        var jCarousel = jQuery( '.carousel' );
        if ( jCarousel.length > 0 ) {
            espresso.bootstrap.carousel.activateFirstItem( jCarousel );
            espresso.bootstrap.carousel.initCarouselNavigation( jCarousel );
            espresso.bootstrap.carousel.initAutoplay( jCarousel );
        }
    };
    // Aktiver f&oslash;rste slide i alle bootstrap carousels
    espresso.bootstrap.carousel.activateFirstItem = function ( jCarousel ) {
        jCarousel.each( function () {
            var jThis = jQuery( this );
            if ( jThis.find( '.carousel-inner .active' ).length !== 1 ) {
                jThis.find( '.carousel-indicators li, .carousel-inner .item' ).filter( ':first-child' ).addClass( 'active' );
                var eCarouselOptions = {};
                if ( jThis.is( '[data-interval="false"]' ) === true ) {
                    eCarouselOptions.interval = false;
                }
                jThis.carousel( eCarouselOptions );
            }
        } );
    };
    espresso.bootstrap.carousel.initCarouselNavigation = function ( jCarousel ) {
        jCarousel.each( function () {
            var jThis = jQuery( this ),
                jThisControls = jThis.find( '.carousel-control' ),
                jThisIndicators = jThis.find( '.carousel-indicators' );
            if ( jThis.find( '.carousel-inner .item' ).length === 1 ) {
                jThisControls.hide();
                jThisIndicators.hide();
            }
            if ( jThisIndicators.length !== 0 ) {
                jThisIndicators.find( 'li' ).each( function ( index ) {
                    jQuery( this ).attr( 'data-slide-to', index );
                } );
            }
            if ( jThis.is( '.e-carousel-content' ) === true ) {
                var jThisIndicatorItems = jThisIndicators.find( 'li' ).css( {
                    width: ( Math.round( 100 / jThisIndicators.find( 'li' ).length * 100 ) / 100 ) + '%'
                } );
                if ( jThis.is( '[data-interval="false"]' ) === true && screen.width >= 1024 ) {
                    jThis.on( 'slid', function () {
                        jThisIndicatorItems.removeClass( 'active' ).eq( jThis.find( '.carousel-inner .active' ).index() ).addClass( 'active' );
                    } );
                    jThisIndicatorItems.on( 'mouseenter', function () {
                        var jThis = jQuery( this );
                        setTimeout( function () {
                            jThis.trigger( 'click.carousel.data-api' );
                        }, 1 );
                    } );
                }
            }
            if ( jThis.is( '.e-carousel-compact' ) === true ) {
                var jThumbnails = jThis.find( 'li' ),
                    jThumbnailsStep = 0,
                    jThumbnailsInView = Math.round( jThis.find( '.js-e-carousel-compact-thumbs' ).width() / jThumbnails.outerWidth() ),
                    jThumbnailsCenter = Math.round( jThumbnailsInView / 2 ),
                    jThumbnailsMaxStep = jThumbnails.length - jThumbnailsInView;
                if ( jThumbnails.length < jThumbnailsInView ) {
                    jThis.find( '.js-e-carousel-compact-thumbs' ).remove();
                }
                else {
                    jThis.find( '.js-e-carousel-compact-thumbs .left' ).addClass( 'inactive' );
                    espresso.constant.jWindow.on( 'resize load', function () {
                        jThis.find( '.carousel-indicators' ).css( {
                            width: jThumbnails.length * ( jThumbnails.outerWidth() + 4 ),
                            height: jThumbnails.find( 'img' ).height()
                        } );
                    } );
                    jThis.find( '.js-e-carousel-compact-thumbs' ).find( 'li' ).each( function ( i ) {
                        i = i + 1;
                        jQuery( this ).data( 'item', i );
                    } );
                    jThis.find( '.js-e-carousel-compact-thumbs' ).find( 'li' ).on( 'click', function () {
                        if ( jQuery( this ).data( 'item' ) > jThumbnailsCenter ) {
                            jThumbnailsStep = jQuery( this ).data( 'item' ) - jThumbnailsCenter;
                            if ( jThumbnailsStep > jThumbnailsMaxStep ) {
                                jThumbnailsStep = jThumbnailsMaxStep;
                            }
                            jThumbnails.css( 'left', ( jThumbnailsStep * -jThumbnails.outerWidth() - 2 ) + 'px' );
                        }
                        if ( jQuery( this ).data( 'item' ) <= jThumbnailsCenter && jThumbnailsStep > 0 ) {
                            jThumbnailsStep = jQuery( this ).data( 'item' ) - jThumbnailsCenter;
                            if ( jThumbnailsStep < 0 ) {
                                jThumbnailsStep = 0;
                            }
                            jThumbnails.css( 'left', ( jThumbnailsStep * -jThumbnails.outerWidth() - 2 ) + 'px' );
                        }
                    } );
                    var jThumbnailSlideLast = jThis.find( '.js-e-carousel-compact-thumbs' ).find( 'li:last' ).data( 'item' );
                    jThis.find( '.carousel-control' ).on( 'click', function ( event ) {
                        event.preventDefault();
                        if ( jQuery( this ).hasClass( 'right' ) ) {
                            if ( jThis.find( '.carousel-indicators' ).find( 'li.active' ).data( 'item' ) === jThumbnailSlideLast ) {
                                jThumbnails.css( 'left', '0px' );
                                jThis.find( '.js-e-carousel-compact-thumbs' ).find( 'li:first' ).trigger( 'click' );
                            }
                            else {
                                jThis.find( '.carousel-indicators' ).find( 'li.active' ).next( 'li' ).trigger( 'click' );
                            }
                        }
                        else if ( jQuery( this ).hasClass( 'left' ) ) {
                            if ( jThis.find( '.carousel-indicators' ).find( 'li.active' ).data( 'item' ) === 1 ) {
                                jThumbnails.css( 'left', -( jThumbnailsMaxStep * jThumbnails.outerWidth() + 2 ) + 'px' );
                                jThis.find( '.js-e-carousel-compact-thumbs' ).find( 'li:last' ).trigger( 'click' );
                            }
                            else {
                                jThis.find( '.carousel-indicators' ).find( 'li.active' ).prev( 'li' ).trigger( 'click' );
                            }
                        }
                    } );
                    jThis.find( '.js-e-carousel-compact-thumbs .left' ).on( 'click', function () {
                        if ( jThumbnailsStep > 0 ) {
                            jThumbnailsStep -= jThumbnailsInView;
                            if ( jThumbnailsStep < 0 ) {
                                jThumbnailsStep = 0;
                            }
                            jThumbnails.css( 'left', ( jThumbnailsStep * -jThumbnails.outerWidth() - 2 ) + 'px' );
                        }
                    } );
                    jThis.find( '.js-e-carousel-compact-thumbs .right' ).on( 'click', function () {
                        if ( jThumbnailsStep < jThumbnailsMaxStep ) {
                            jThumbnailsStep += jThumbnailsInView;
                            if ( jThumbnailsStep > jThumbnailsMaxStep ) {
                                jThumbnailsStep = jThumbnailsMaxStep;
                            }
                            jThumbnails.css( 'left', -( jThumbnailsStep * jThumbnails.outerWidth() + 2 ) + 'px' );
                        }
                    } );
                    jThis.find( '.js-e-carousel-compact-thumbs, .js-e-carousel-compact-thumbs li' ).on( 'click', function () {
                        if ( jThumbnailsStep === jThumbnailsMaxStep ) {
                            jThis.find( '.js-e-carousel-compact-thumbs .right' ).addClass( 'inactive' );
                            jThis.find( '.js-e-carousel-compact-thumbs .left' ).removeClass( 'inactive' );
                        }
                        else if ( jThumbnailsStep < jThumbnailsMaxStep && jThumbnailsStep !== 0 ) {
                            jThis.find( '.js-e-carousel-compact-thumbs .right' ).removeClass( 'inactive' );
                            jThis.find( '.js-e-carousel-compact-thumbs .left' ).removeClass( 'inactive' );
                        }
                        else if ( jThumbnailsStep === 0 ) {
                            jThis.find( '.js-e-carousel-compact-thumbs .left' ).addClass( 'inactive' );
                            jThis.find( '.js-e-carousel-compact-thumbs .right' ).removeClass( 'inactive' );
                        }
                    } );
                }
            }
        } );
    };
    espresso.bootstrap.carousel.initAutoplay = function ( jCarousel ) {
        jCarousel.filter( '[data-autoplay="true"]' ).carousel( 'cycle' );
    };
    espresso.bootstrap.modal = {};
    espresso.bootstrap.modal.init = function () {
        jQuery( '.e-modal-fixed' ).on( 'show', function () {
            jQuery( document.body ).addClass( 'e-modal-fixed-backdrop' );
        } ).on( 'hidden', function () {
            jQuery( document.body ).removeClass( 'e-modal-fixed-backdrop' );
        } ); //.filter( ':visible' ).triggerHandler( 'show' );
    };
    espresso.bootstrap.affix = {};
    espresso.bootstrap.affix.init = function () {
        espresso.bootstrap.affix.setAffix();
        espresso.bootstrap.affix.addPlaceholder();
        espresso.bootstrap.affix.setPlaceholderHeight();
        espresso.bootstrap.affix.bindEvents();
    };
    espresso.bootstrap.affix.setAffix = function () {
        var jNavGlobalTop = jQuery( '.js-e-nav-global-top' ),
            jNavLocalTop = jQuery( '.js-e-nav-local-top' );
        if ( jNavLocalTop.length === 1 && screen.height > 767 ) {
            jNavLocalTop.removeData( 'affix' ).removeClass( 'affix affix-top affix-bottom' );
            jNavLocalTop.affix( {
                offset: {
                    top: jNavLocalTop.position().top
                }
            } );
        }
        else if ( jNavGlobalTop.length === 1 && screen.height > 480 ) {
            jNavGlobalTop.removeData( 'affix' ).removeClass( 'affix affix-top affix-bottom' );
            jNavGlobalTop.affix( {
                offset: {
                    top: jNavGlobalTop.position().top
                }
            } );
        }
    };
    espresso.bootstrap.affix.addPlaceholder = function () {
        var jNavGlobalTop = jQuery( '.js-e-nav-global-top' ),
            jNavLocalTop = jQuery( '.js-e-nav-local-top' );
        if ( jNavLocalTop.length === 1 && screen.height > 767 ) {
            jNavLocalTop.wrap( jQuery( '<div />' ).addClass( 'js-e-nav-sticky-wrapper' ).css( {
                'min-height': jNavLocalTop.outerHeight( true )
            } ) );
        }
        else {
            jNavGlobalTop.wrap( jQuery( '<div />' ).addClass( 'js-e-nav-sticky-wrapper' ).css( {
                'min-height': jNavGlobalTop.outerHeight( true )
            } ) );
        }
    };
    espresso.bootstrap.affix.setPlaceholderHeight = function () {
        jQuery( '.js-e-nav-sticky-wrapper' ).css( 'min-height', function () {
            return jQuery( this ).children().first().outerHeight( true );
        } );
    };
    espresso.bootstrap.affix.bindEvents = function () {
        espresso.constant.jWindow.on( 'resize', function () {
            espresso.constant.jWindow.off( '.affix' );
            espresso.bootstrap.affix.setAffix();
            espresso.bootstrap.affix.setPlaceholderHeight();
        } );
    };
    // fjern fokus fra bootstrap tabs efter der er klikket
    espresso.bootstrap.tabs = {};
    espresso.bootstrap.tabs.onFocusThisBlur = function () {
        jQuery( '.nav-tabs a[data-toggle="tab"]' ).on( 'focus', function () {
            jQuery( this ).trigger( 'blur' );
        } );
    };
    espresso.bootstrap.dropdown = {};
    espresso.bootstrap.dropdown.fixTouchClickIssue = function () {
        jQuery( 'body' ).on( 'touchstart.dropdown', '.dropdown-menu', function ( event ) {
            event.stopPropagation();
        } ).on( 'click', '.dropdown-menu a', function ( event ) {
            event.stopPropagation();
        } );
        /*$('.dropdown-menu').click(function(event){
        event.stopPropagation();
        } );*/
    };
}() );
